// Variables du bloc texte libre (docs/EDITEUR-MISE-EN-PAGE.md §5) : mêmes jetons que Signitic.
// Un jeton vide disparaît, ainsi que la ponctuation isolée qu'il laisse derrière lui.
// Les valeurs sont insérées telles quelles ici (texte brut) : l'échappement HTML est fait par le
// rendu sur le résultat entier, systématiquement.

export const TEMPLATE_VARIABLES = ['prenom', 'nom', 'fonction', 'lieu', 'email', 'tel_mobile', 'tel_fixe', 'adresse', 'site'] as const;
export type TemplateVariable = (typeof TEMPLATE_VARIABLES)[number];
export type TemplateValues = Partial<Record<TemplateVariable, string | null | undefined>>;

/** Séparateurs de ponctuation qui n'ont de sens qu'entre deux valeurs. */
const SEP = '(?:·|•|\\||—|–|-|,|;|/)';

/** Nettoie une ligne : séparateurs en début/fin, séparateurs doublés, espaces multiples. */
export function tidyPunctuation(line: string): string {
  let s = line;
  let prev = '';
  while (s !== prev) {
    prev = s;
    s = s
      .replace(new RegExp(`^\\s*${SEP}\\s*`), '') // séparateur en tête
      .replace(new RegExp(`\\s*${SEP}\\s*$`), '') // séparateur en fin
      .replace(new RegExp(`(\\s*${SEP}\\s*)(?:${SEP}\\s*)+`), '$1'); // séparateurs enchaînés → un seul
  }
  return s.replace(/[ \t]{2,}/g, ' ').trim();
}

/** Remplace {{jeton}} par sa valeur (jeton inconnu = vide), puis nettoie chaque ligne. Lignes vides supprimées. */
export function expandTemplate(text: string, values: TemplateValues): string {
  return text
    .split(/\r?\n/)
    .map((line) => tidyPunctuation(line.replace(/\{\{\s*([a-z_]+)\s*\}\}/gi, (_, key: string) => values[key.toLowerCase() as TemplateVariable] ?? '')))
    .filter((line) => line !== '')
    .join('\n');
}
